module.exports = {
  title: 'ZeroToHero',
  description: '',
  seoImage: '',
  color: '#000000'
};
